// import * as actions from './actions';
// import * as props from './component-props';
import appReducer from './reducer';

export {
  // actions,
  // props,
  appReducer,
};



// WEBPACK FOOTER //
// ./src/model/index.js